module.exports = __webpack_public_path__ + "static/media/image2.2eb3e978.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/VipRoom/images/image2.jpg
// module id = 440
// module chunks = 0